import { redirect } from 'next/navigation';
import { getServerFeatureFlag } from '../../../statsig/sdk/server';
import { TFunction } from 'i18next';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { NavigationBackButton } from '../../../navigation';
import { FilledDismiss } from '../../../common/svgIcons';
import { NavigationBar } from '../../../common';
import { getStakeTranslations } from '../../utils/getStakeTranslations';
import { AcceptUnstakeSummary } from '../AcceptUnstakeSummary/AcceptUnstakeSummary';
import {
  getAssetUnstakingOverviewData,
  getUnstakeAssetAcceptData,
} from '../../../common/gqlActions';
import { PrecisionFloat } from '@bts-web/utils-formatting';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { GenericErrorMessage } from '../../../layouts/GenericErrorMessage/GenericErrorMessage';

export type AcceptUnstakeControllerProps = {
  assetId: string;
  amount: string;
};

export const AcceptUnstakeController = async ({
  assetId,
  amount,
}: AcceptUnstakeControllerProps) => {
  const { t } = await initServerTranslation();

  const translations = getStakeTranslations(t as TFunction);

  const feature_hasStakingEnabled = await getServerFeatureFlag(
    'feature_hasStakingEnabled',
  );

  if (!feature_hasStakingEnabled) {
    redirect(NEXT_ROUTES.PORTFOLIO);
  }

  const [unstakeAssetAcceptData, assetUnstakingOverviewData] =
    await Promise.all([
      getUnstakeAssetAcceptData({
        assetId,
      }),
      getAssetUnstakingOverviewData({ assetId }),
    ]);

  if (
    unstakeAssetAcceptData.errors ||
    !unstakeAssetAcceptData.data?.unstakeAsset
  ) {
    return <GenericErrorMessage />;
  }

  if (
    !unstakeAssetAcceptData.data.unstakeAsset.items ||
    unstakeAssetAcceptData.data.unstakeAsset.items.length === 0
  ) {
    return <GenericErrorMessage />;
  }

  const unstakeAsset = unstakeAssetAcceptData.data.unstakeAsset.items[0];

  const currentUnstaked = assetUnstakingOverviewData.data.bondedStakingOverview
    ?.totalBondedFiat as PrecisionFloat | undefined;

  return (
    <>
      <NavigationBar
        showBorderBottom
        title={translations.summary}
        NavigationLeftSlot={<NavigationBackButton />}
        NavigationRightSlot={
          <NavigationBackButton icon={<FilledDismiss size={24} />} />
        }
      />
      <AcceptUnstakeSummary
        unstakeAsset={unstakeAsset}
        currentUnstaked={currentUnstaked}
        translations={translations}
        assetId={assetId}
        amount={amount}
      />
    </>
  );
};
